import React from 'react';
import PropTypes from 'prop-types';
import EmailInput from './emailInput';
import AutoComplete from '../../containers/autoCompleteContainer';
import ErrorDisplay from '../shared/errorDisplay';

const InviteArea = props => {
  const errorOutput = {
    'invalid-format': props.translations['invalid-email-format'],
    required: props.translations['this-is-required'],
    'network-invite':
      'There was an error sending your invites. Please try again.',
    'Emails-greater-than-75': 'Please enter only up to 75 emails'
  };

  let buttonClickFunction;
  let ensureAnniversary;
  let ensureAnniversaryOther;
  let isLeader;
  let isRestricted;
  let peerCommentsValue;
  let photosAllowed;
  let postUrl;
  let useV3;

  if (props.invites && props.invites.href) {
    isLeader = props.invites.href.includes('leader');
  }

  if (
    props.invites.program &&
    (props.invites.program.peer || props.invites.program.manager)
  ) {
    photosAllowed = isLeader
      ? props.invites.program.manager.image.allowed
      : props.invites.program.peer.image.allowed;
  }

  peerCommentsValue = "";
  if (props.translations['ensure-anniversary'] && props.invites.program) {
    ensureAnniversary = props.translations['ensure-anniversary']
      .replace('%{level}', props.invites.level)
      .replace('%{name}', props.invites.user.name);
    ensureAnniversaryOther = props.translations[
      'ensure-anniversary-other'
    ].replace('%{name}', props.invites.user.name);


    console.info('STP:  ');
    console.info(props.invites.user.stp);
    console.info('Program Type:  ');
    console.info(props.invites.program.type);

    // TODO #4 If NYP
    if(props.invites.user.stp === '0001170328' && props.invites.program.type === 'Retirement') {
      ensureAnniversaryOther = 'Ensure a powerful and memorable experience.';
    }

    isRestricted =
      props.invites.program &&
      props.invites.program.restrictedEmails &&
      props.invites.program.restrictedEmails.length > 0;

    if (isRestricted) {
      peerCommentsValue = photosAllowed
        ? props.translations['restricted-peer-comments-value']
        : props.translations['restricted-peer-comments-value-photos-disabled'];
    } else {
      peerCommentsValue = photosAllowed
        ? props.translations['peer-comments-value']
        : props.translations['peer-comments-value-photos-disabled'];

      // TODO:  #5 If NYP
      if(props.invites.user.stp === '0001170328' && props.invites.program.type === 'Retirement') {
        peerCommentsValue = 'Enter the email addresses of teammates and they’ll be invited to add their own unique comments, photos and tributes to the Yearbook we are preparing.';
      }
    }
  }

  if (
    props.invites &&
    (props.invites.invite_v3 || props.invites.invite_v2 || props.invites.invite)
  ) {
    useV3 = !!(props.invites.invite_v3 && props.invites.invite_v3.action);

    if (useV3) {
      postUrl = props.invites.invite_v3.action;
    } else if (props.invites.invite_v2) {
      postUrl = props.invites.invite_v2.action;
    } else {
      postUrl = props.invites.invite.action;
    }

    buttonClickFunction = props.invites.people
      ? props.autoCompleteSubmit.bind(null, postUrl, useV3)
      : props.emailSubmit.bind(null, postUrl, useV3);
  }

  /* eslint-disable jsx-a11y/anchor-is-valid */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <div>
      <h1>
        {props.invites.program.type === 'Service'
          ? ensureAnniversary
          : ensureAnniversaryOther}
      </h1>
      <p>
        {peerCommentsValue.replace('%{name}', props.invites.user.firstName)}
      </p>

      <a
        style={{ color: props.invites.program.color }}
        className="invite-whom"
        onClick={() => props.displayModal('invite-suggestion')}
      >
        {props.translations['whom-to-invite']}
      </a>

      <fieldset className="user-search">
        <legend>{props.translations['enter-email']}</legend>
        {props.error &&
          Object.prototype.hasOwnProperty.call(errorOutput, props.error) &&
          !props.modalOnDisplay && (
            <ErrorDisplay errorMessage={errorOutput[props.error]} />
          )}
        {props.invites && props.invites.people ? (
          <AutoComplete
            searchUrl={props.invites.people}
            color={props.invites.program.color}
          />
        ) : (
          <EmailInput
            translations={props.translations}
            error={props.error}
            enterPush={props.enterPush}
            postUrl={postUrl}
            expandTextArea={props.expandTextArea}
            inputAreaHeight={props.inputAreaHeight}
            useV3={useV3}
          />
        )}
      </fieldset>

      <button
        className={props.spinnerDisplay ? 'form-loading' : null}
        type="button"
        style={{ backgroundColor: props.invites.program.color }}
        onClick={buttonClickFunction}
      >
        {props.translations['send-invite']}
      </button>
    </div>
  );
  /* eslint-enable jsx-a11y/anchor-is-valid */
  /* eslint-enable jsx-a11y/click-events-have-key-events */
  /* eslint-enable jsx-a11y/no-static-element-interactions */
};

InviteArea.propTypes = {
  autoCompleteSubmit: PropTypes.func.isRequired,
  displayModal: PropTypes.func,
  emailSubmit: PropTypes.func.isRequired,
  enterPush: PropTypes.func,
  error: PropTypes.string,
  expandTextArea: PropTypes.func,
  inputAreaHeight: PropTypes.string.isRequired,
  invites: PropTypes.shape({
    people: PropTypes.string,
    autoInvites: PropTypes.array,
    sent: PropTypes.array,
    href: PropTypes.string,
    invite: PropTypes.shape({
      action: PropTypes.string,
    }),
    invite_v2: PropTypes.shape({
      action: PropTypes.string,
    }),
    invite_v3: PropTypes.shape({
      action: PropTypes.string,
    }),
    level: PropTypes.string,
    user: PropTypes.shape({
      firstName: PropTypes.string,
      name: PropTypes.string,
      stp: PropTypes.string,
    }),
    program: PropTypes.shape({
      type: PropTypes.string,
      color: PropTypes.string,
      restrictedEmails: PropTypes.array,
      peer: PropTypes.shape({
        image: PropTypes.shape({
          allowed: PropTypes.bool,
        }),
      }),
      manager: PropTypes.shape({
        image: PropTypes.shape({
          allowed: PropTypes.bool,
        }),
      }),
    }),
  }).isRequired,
  modalOnDisplay: PropTypes.string,
  spinnerDisplay: PropTypes.bool.isRequired,
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
};

InviteArea.defaultProps = {
  displayModal: () => {},
  enterPush: () => {},
  error: '',
  expandTextArea: () => {},
  modalOnDisplay: '',
};

export default InviteArea;
